<app-widget [widget-meta]="this.data"
  hidehelp="false">
  @if (profileService.profile$ | async; as profile) {
    @if (pages.data$ | async; as pages) {
      <div>
        <div>
          <label for="filterPages" class="sr-only">Type to filter the list</label>
          <input type="search" id="filterPages" [(ngModel)]="filterText" class="form-control" placeholder="Filter...">
        </div>
        <table class="table file-table">
          <thead>
            <tr>
              <!--<th>Favorite</th>-->
              <th sortable="Title" scope="col" (sort)="onSort($event)" [data]="pages">Name</th>
              <th sortable="Category" scope="col" (sort)="onSort($event)" [data]="pages">Category</th>
            </tr>
          </thead>
          <tbody>
            @for (item of pages  | linkFilter: filterText; track item) {
              <tr>
                <!--<td>
                <span class="icon" (click)="updateFavorite(profile.favorites, item)" [attr.aria-label]="profile.favorites.includes(item.Id)?'Favorite':'Not Favorite'">
                  <i class="fas fa-heart" aria-hidden="true" [class.active]="profile.favorites.includes(item.Id)" title="Favorite this link?"></i>
                </span>
              </td>-->
              <td><a href="content?id={{item.Id}}" target="_blank" (click)="linkClicked(item)">{{item.Title}}</a></td>
              <td>{{item.Category}}</td>
            </tr>
          }
          @if (!!!pages || pages.length === 0;) {
            <tr>
              <td colspan="2"><span>Darn! We couldn't find any pages for you. If you think this is not correct reach out to the IT Service Desk at <a href="mailto:itservicedesk@kenan-flagler.unc.edu">itservicedesk&#64;kenan-flagler.unc.edu</a>.</span></td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  } @else {
    <ng-template [ngTemplateOutlet]="loadingOrError.template"></ng-template>
  }
} @else {
  <ng-template [ngTemplateOutlet]="loadingOrError.template"></ng-template>
}

<loading-or-error #loadingOrError
  [loadingWrapper]="pages"
  [errorMessage]="'Oops! Looks like we can\'t get information for Pages!'">
</loading-or-error>
</app-widget>

